module.exports = __webpack_public_path__ + "2817f2cefb14ae8e349ad929b4af7b69.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ui/assets/images/groups/PowerWhite.jpg
// module id = 1290
// module chunks = 0